/// <reference types="arcgis-js-api" />
/*
  Copyright 2020 Esri
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { loadModules } from 'esri-loader';
import { setDefaultOptions } from 'esri-loader';
import esri = __esri;
import { add } from 'esri/views/3d/externalRenderers';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { event } from 'jquery';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-esri-map',
  templateUrl: './esri-map.component.html',
  styleUrls: ['./esri-map.component.css']
})
export class EsriMapComponent implements OnInit, OnDestroy {
  searchAddress: string;
  latitude: number;
  longitude: number;
  @Output() mapLoaded = new EventEmitter<boolean>();
  @Input() searchLocation: any;

  private esriSubscription: Subscription[] = [];

  ngOnDestroy() {
      this.esriSubscription.forEach(sub => sub.unsubscribe());
        this.esriSubscription = [];
    
  }
  @Output() childComponentValue = new EventEmitter<any>();
  @ViewChild('mapViewNode', { static: true }) private mapViewEl: ElementRef;

  private _zoom: number = 200;
  private _center: Array<number> = [-85.1394, 41.7606];
  private _basemap: string = 'streets';

  EsriMapView: any;

  @Input()
  set zoom(zoom: number) {
    this._zoom = zoom;
  }

  get zoom(): number {
    return this._zoom;
  }

  @Input()
  set center(center: Array<number>) {
    this._center = center;
  }

  get center(): Array<number> {
    return this._center;
  }

  @Input()
  set basemap(basemap: string) {
    this._basemap = basemap;
  }

  get basemap(): string {
    return this._basemap;
  }

  constructor(private agentscriptservice: AgentscriptService_updated) {}

  selectedmap = 'streets-vector';
  assignAddress(item: any) {
    this.addressSuggestions = [];
    var streetAddress = item.split(',')[0].trim();
    console.log(item);
    this.selectedmap = $('.pane:visible [data-basemap-id]').attr('data-basemap-id');
    // this.togglemap=
    // console.log(this.selectedmap)
    // console.log($('[data-basemap-id]').attr('data-basemap-id'))
    this.addressvalue = item;
    // this.suggestionSearch()

    var k = this.agentscriptservice.fetchData(this.tab_title, 'casetypedata');
    let casetypeid = k.serviceDetails.casetypeid;
    console.log(k.serviceDetails.casetypeid);
    this.agentscriptservice.fetchaddressdetails(streetAddress, 'Address', casetypeid).subscribe((data: any) => {
      this.fetchaddressdetails = data;
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', this.fetchaddressdetails);
      console.log(this.fetchaddressdetails);

      this.agentscriptservice.locationcoordinates = this.fetchaddressdetails;

      const coords = {
        msr_addresstype: this.fetchaddressdetails?.address_type + ' IN',
        msr_serviceaddress: this.fetchaddressdetails?.returned_address,
        msr_city: this.fetchaddressdetails?.personal_data.property_address_city,
        msr_state: this.fetchaddressdetails?.personal_data.mailing_state,
        msr_zip: this.fetchaddressdetails?.address_details.zip,
        msr_withinlimits: this.fetchaddressdetails?.address_details.within_limits,
        msr_recycleweek: this.fetchaddressdetails?.address_details.recycle_week_ID,
        msr_collectionday: this.fetchaddressdetails?.address_details.collection_day,
        msr_jurisdiction: this.fetchaddressdetails?.address_details.jurisdiction,
        msr_next_collection_day: this.fetchaddressdetails?.address_details.next_collection_day,
        msr_zoning: this.fetchaddressdetails?.address_details.zoning_id,
        msr_lat: this.fetchaddressdetails?.lat,
        msr_lng: this.fetchaddressdetails?.lng,
        msr_parcelnumber: this.fetchaddressdetails?.personal_data.parcel_number,
        msr_nearbyIncidents: this.fetchaddressdetails?.nearby_incidents
        // msr_parcelnumber: this.fetchaddressdetails.personal_data.parcel_number,
      };

      console.log(coords);

      // this.agentscriptservice.isGisVerified=true;
      this.childComponentValue.emit(coords);

      this.geocodeAndCenter(streetAddress);
    });
  }
  clearsearch() {
    this.addressvalue = '';
  }

  checkIfEmpty() {
    console.log('keyup');
    if (this.addressvalue! == '') {
      this.clearsearch();
    }
  }

  onDropdownChange() {
    console.log(this.addressvalue);
    // this.geocodeAndCenter(this.addressvalue)
  }

  addressSuggestions: any;
  addressvalue: any;
  fetchaddressdetails: any;

  suggestionSearch() {
    console.log(this.addressSuggestions?.length);
    console.log(this.addressvalue);

    this.performAddressSearch(this.addressvalue);
    if (this.addressvalue == '') {
      this.addressSuggestions = [];
    }
  }

  async performAddressSearch(searchTerm: string) {
    if (searchTerm != '') {
      try {
        // Trim the search term to remove any leading or trailing spaces
        const trimmedSearchTerm = searchTerm.trim();
        console.log(trimmedSearchTerm);

        if (trimmedSearchTerm !== '') {
          // Check if search term is not empty
          this.agentscriptservice.mapsuggestions(trimmedSearchTerm).subscribe((response: any) => {
            console.log(response.suggestions);
            this.addressSuggestions = response.suggestions.map((suggestion: { text: any }) => suggestion.text);
            console.log(this.addressSuggestions);
          });
        } else {
          // Clear suggestions if search term is empty
          this.addressSuggestions = [];
        }
      } catch (error) {
        console.error('Error fetching address suggestions:', error);
      }
    }
  }

  geocodeAndCenter(address: any) {
    console.log(address);
    if (!address) {
      console.log('it is not addrss');

      this.initializeMap();
      return;
    }
    console.log('loadmap address', address);
    console.log(address);
    var streetAddress = address.split(',')[0].trim();
    console.log(streetAddress);
    if (streetAddress.includes('&') || streetAddress.includes('and')) {
      console.log('presence of and / || detected');
      this.agentscriptservice.streetlocator(streetAddress).subscribe(
        async response => {
          console.log(streetAddress);
          console.log(response.candidates);
          if (response && response.candidates && response.candidates.length > 0) {
            // this.agentscriptservice.fetchaddressdetails(streetAddress,'Intersection').subscribe((data:any)=>{
            //   this.fetchaddressdetails=data
            //   console.log(this.fetchaddressdetails)

            //   this.agentscriptservice.locationcoordinates=this.fetchaddressdetails

            //   const coords = {
            //     msr_addresstype:this.fetchaddressdetails.address_type,
            //     msr_serviceaddress:this.fetchaddressdetails.returned_address,
            //     msr_city: this.fetchaddressdetails.personal_data.property_address_city,
            //     msr_state: this.fetchaddressdetails.personal_data.mailing_state,
            //     msr_zip: this.fetchaddressdetails.address_details.zip,
            //     msr_withinlimits: this.fetchaddressdetails.address_details.within_limits,
            //     msr_recycleweek:this.fetchaddressdetails.address_details.recycle_week_ID,
            //     msr_collectionday:this.fetchaddressdetails.address_details.collection_day,
            //     msr_jurisdiction:this.fetchaddressdetails.address_details.jurisdictionname,
            //     msr_zoning:this.fetchaddressdetails.address_details.zoning_id,
            //     msr_lat: this.fetchaddressdetails.lat,
            //     msr_lng: this.fetchaddressdetails.lng,
            //     msr_parcelnumber: this.fetchaddressdetails.personal_data.parcel_number,
            //     msr_nearbyIncidents:this.fetchaddressdetails.nearby_incidents
            //     // msr_parcelnumber: this.fetchaddressdetails.personal_data.parcel_number,
            //   };

            //   console.log(coords)

            //   this.agentscriptservice.isGisVerified=true;
            //   this.childComponentValue.emit(coords);

            //   this.loadmapping(response)

            // })

            this.agentscriptservice.updateOrInsertArray(this.tab_title, 'loadmappingresponse', response);
            this.loadmapping();
          } else if (response.candidates.length == 0) {
            // alert('please enter valid address');
            streetAddress = streetAddress + '';
            // this.initializeMap();
          }
        },

        error => {
          console.error('Error geocoding address:', error);
        }
      );
    } else {
      console.log('in else' + streetAddress);
      this.agentscriptservice.addresslocator(streetAddress).subscribe(
        async response => {
          console.log(streetAddress);
          console.log(response);
          console.log(response.candidates.length);
          if (response && response.candidates && response.candidates.length > 0) {
            const candidate = response.candidates[0];
            const location = candidate.location;
            console.log(location);
            if (location && location.x && location.y) {
              //   const [EsriMap, EsriMapView, Graphic, PopupTemplate,BasemapToggle] = await loadModules([
              //     'esri/Map',
              //     'esri/views/MapView',
              //     'esri/Graphic',
              //     'esri/PopupTemplate',
              //      'esri/widgets/BasemapToggle',
              //   ]);

              //   // console.log(this.selectedmap)
              //   const map = new EsriMap({
              //     basemap: this.selectedmap=='satellite'?'streets-vector':'satellite',
              //     // basemap: this._basemap,

              //   //   basemap: this.selectedmap=='satellite'?'streets-vector':'satellite',
              //   });

              //   console.log(map)

              //   const view = new EsriMapView({
              //     container: this.mapViewEl.nativeElement,
              //     center: [location.x, location.y],
              //     zoom: 16, // Adjust the zoom level as needed
              //     map: map
              //   });

              //   // Create a popup template for the address
              //   const popupTemplate = new PopupTemplate({
              //     title: "Location",
              //     content: streetAddress // You can customize the content of the popup as needed
              //   });
              //   const markerSymbol = {
              //     type: 'picture-marker',
              //     url: '../../assets/images/map-pin-red.png',
              //     width: '20px',
              //     height: '30px'
              //   };
              //   // Create a graphic (marker) at the geocoded location
              //   const markerGraphic = new Graphic({
              //     geometry: {
              //       type: 'point',
              //       longitude: location.x,
              //       latitude: location.y
              //     },
              //     symbol: markerSymbol,
              //     popupTemplate: popupTemplate
              //   });

              //   const toggle = new BasemapToggle({
              //     view: view,
              //     nextBasemap: this.selectedmap=='satellite'?'satellite':'streets-vector'
              // });

              // view.ui.add(toggle, {
              //     position: "bottom-right"
              // });
              // Add the marker graphic to the map
              // view.graphics.add(markerGraphic);

              // this.agentscriptservice.fetchaddressdetails(streetAddress,'Address').subscribe((data:any)=>{
              //   this.fetchaddressdetails=data
              //   console.log(this.fetchaddressdetails)

              //   this.agentscriptservice.locationcoordinates=this.fetchaddressdetails

              //   const coords = {
              //     msr_addresstype:this.fetchaddressdetails.address_type,
              //     msr_serviceaddress:this.fetchaddressdetails.returned_address,
              //     msr_city: this.fetchaddressdetails.personal_data.property_address_city,
              //     msr_state: this.fetchaddressdetails.personal_data.mailing_state,
              //     msr_zip: this.fetchaddressdetails.address_details.zip,
              //     msr_withinlimits: this.fetchaddressdetails.address_details.within_limits,
              //     msr_recycleweek:this.fetchaddressdetails.address_details.recycle_week_ID,
              //     msr_collectionday:this.fetchaddressdetails.address_details.collection_day,
              //     msr_jurisdiction:this.fetchaddressdetails.address_details.jurisdictionname,
              //     msr_zoning:this.fetchaddressdetails.address_details.zoning_id,
              //     msr_lat: this.fetchaddressdetails.lat,
              //     msr_lng: this.fetchaddressdetails.lng,
              //     msr_parcelnumber: this.fetchaddressdetails.personal_data.parcel_number,
              //     msr_nearbyIncidents:this.fetchaddressdetails.nearby_incidents
              //     // address: candidate.address,
              //     // msr_address_t: this.fetchaddressdetails.personal_data.property_address_city
              //   };

              //   console.log(coords)
              //   this.agentscriptservice.isGisVerified=true;
              //   this.childComponentValue.emit(coords);

              //   this.loadmapping(response)

              // })
              this.agentscriptservice.updateOrInsertArray(this.tab_title, 'loadmappingresponse', response);
              this.loadmapping();
              // .subscribe((data:any)=>{
              //   console.log(data)
              // })
              // Show the popup for the marker graphic by default
              // view.popup.open({
              //   features: [markerGraphic],
              //   location: markerGraphic.geometry
              // });
            }
          } else if (response.candidates.length == 0) {
            const coords = {
              msr_addresstype: '',
              msr_serviceaddress: '',
              msr_city: '',
              msr_state: '',
              msr_zip: '',
              msr_withinlimits: '',
              msr_recycleweek: '',
              msr_collectionday: '',
              msr_jurisdiction: '',
              msr_zoning: '',
              msr_lat: '',
              msr_lng: '',
              msr_parcelnumber: '',
              msr_next_collection_day: ''
            };

            // this.agentscriptservice.isGisVerified=false;
            this.childComponentValue.emit(coords);
            // alert('please enter valid address 400');
            this.initializeMap();
          }
        },

        error => {
          console.error('Error geocoding address:', error);
        }
      );
    }
  }

  basicContent: any = [];
  loadfieldvalues() {
    var NCC = [302, 301, 246, 249];

    var k = this.agentscriptservice.fetchData(this.tab_title, 'casetypedata');
    let casetypeid = k?.serviceDetails?.casetypeid ? k.serviceDetails.casetypeid : '';
    console.log(k?.serviceDetails?.casetypeid);

    this.basicContent = [
      {
        type: 'fields',
        fieldInfos: [
          {
            fieldName: 'deedowner',
            label: 'Deed Owner'
          },
          {
            fieldName: 'mailing',
            label: 'Mailing Address'
          },
          {
            fieldName: 'township',
            label: 'Township'
          },
          {
            fieldName: 'muncipality',
            label: 'Muncipality'
          },
          {
            fieldName: 'subdivision',
            label: 'Subdivision'
          },
          {
            fieldName: 'propertyAddress',
            label: 'Property Address'
          },
          {
            fieldName: 'propertyClass',
            label: 'Property Class'
          },
          {
            fieldName: 'parcelNumber',
            label: 'Parcel Number'
          }
        ]
      }
      // ,{
      //   type: "text",
      //   text: "This is additional static content in the popup."
      // }
    ];

    // NCC is ['302', '301', '246', '249']
    if (NCC.includes(casetypeid)) {
      this.basicContent[0].fieldInfos.push({
        fieldName: 'NCC',
        label: 'NCC'
      });
    }
    if (casetypeid == '251') {
      this.basicContent[0].fieldInfos.push({
        fieldName: 'SnowRoute',
        label: 'Snow Route'
      });
    }
    if (casetypeid == '238') {
      this.basicContent[0].fieldInfos.push({
        fieldName: 'LeafPickUp',
        label: 'Leaf Pick Up'
      });
    }
  }
  layersdata: any = [];
  layersdatafunction() {
    this.layersdata = [{}];
  }
  layerlayer: any = '';
  layerlayer1: any = '';
  // entirelayers: any[] = [
  //   {

  //       layerurl: '30'
  //   },
  //   {
  //       layerurl: '36'
  //   }
  // ];
  esrimapview: any;
  entirelayers: any = [];

  async loadmapping() {
    var response = this.agentscriptservice.fetchData(this.tab_title, 'loadmappingresponse');
    console.log(response);
    // this.layerlayer='https://gis.acimap.us/311admin/rest/services/311/FortWayne311/MapServer/30'
    // this.layerlayer1='https://gis.acimap.us/311admin/rest/services/311/FortWayne311/MapServer/36'

    this.loadfieldvalues();
    // console.log(this.fetchaddressdetails)
    // console.log(this.fetchaddressdetails.personal_data)
    // console.log(this.fetchaddressdetails.personal_data.deed_owner_1)
    const candidate = response.candidates[0];
    const location = candidate.location;
    console.log(location);
    if (location && location.x && location.y) {
      const [EsriMap, EsriMapView, Graphic, GraphicsLayer, PopupTemplate, BasemapToggle, FeatureLayer] = await loadModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/Graphic',
        'esri/layers/GraphicsLayer',
        'esri/PopupTemplate',
        'esri/widgets/BasemapToggle',
        'esri/layers/FeatureLayer'
      ]);

      //   if (true) {
      //     basicContent.push({
      //       "fieldName": "parcelNumber",
      //       label: "Parcel Number"
      //     });
      // }

      // var basicccontent=this.basicContent

      // Create a popup template for the address
      const popupTemplate = new PopupTemplate({
        title: 'Address',
        content: this.basicContent
      });

      const graphicsLayer = new GraphicsLayer();

      const markerSymbol = {
        type: 'picture-marker',
        url: '../../assets/images/map-pin-red.png',
        width: '20px',
        height: '30px'
      };

      // alert('')
      var mapdata = this.agentscriptservice.fetchData(this.tab_title, 'mapdata');

      console.log(mapdata);
      // Create a graphic (marker) at the geocoded location
      const markerGraphic = new Graphic({
        geometry: {
          type: 'point',
          longitude: location.x,
          latitude: location.y
        },
        attributes: {
          deedowner: mapdata.personal_data.deed_owner_1,
          mailing: mapdata.personal_data.mailing_address_1,
          township: mapdata.personal_data.township,
          muncipality: mapdata.personal_data.muncipality,
          subdivision: mapdata.personal_data.subdivision,
          propertyAddress: mapdata.personal_data.property_address,
          propertyClass: mapdata.personal_data.property_class,
          parcelNumber: mapdata.personal_data.parcel_number,
          NCC: 'NCC',
          SnowRoute: 'SnowRoute',
          LeafPickUp: 'LeafPickUp'
        },
        // attributes: {
        //   deedowner:    "hehe",
        //   mailing:      "hehe",
        //   township:     "hehe",
        //   muncipality:  "hehe",
        //   subdivision:      "hehe",
        //   propertyAddress: "hehe",
        //   propertyClass: "hehe",
        //   parcelNumber:  "hehe",
        // },
        symbol: markerSymbol,
        popupTemplate: popupTemplate
      });

      graphicsLayer.add(markerGraphic);

      //var locator = new esri.tasks.Locator("https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer");

      // const layersToAdd = this.entirelayers().map((item: any) => new FeatureLayer({ url: item.layerurl }));

      // const layersToAdd = this.entirelayers.map((item: any) => {
      //   return new FeatureLayer({ url: `https://gis.acimap.us/311admin/rest/services/311/FortWayne311/MapServer/${item.layerurl}` });
      // });

      // if(this.entirelayers.length>0)
      //   {
      //     layersToAdd = this.entirelayers.map((key: string) => {
      //       console.log(`https://gis.acimap.us/311admin/rest/services/311/FortWayne311/MapServer/${key}`)
      //       return new FeatureLayer({ url: `https://gis.acimap.us/311admin/rest/services/311/FortWayne311/MapServer/${key}` });
      //     });

      //   console.log(layersToAdd)

      //      map = new EsriMap({
      //       basemap: this.selectedmap == 'satellite' ? 'streets-vector' : 'satellite',
      //       layers: [
      //           new GraphicsLayer(),
      //           ...layersToAdd
      //         ]
      //       });
      //   }
      //   else{
      //      map = new EsriMap({
      //       basemap: this.selectedmap == 'satellite' ? 'streets-vector' : 'satellite',
      //       layers: [
      //           new GraphicsLayer(),
      //         ]
      //       });
      //   }

      const layersToAdd = this.entirelayers.map((key: string) => {
        return new FeatureLayer({ url: `https://gis.acimap.us/311admin/rest/services/311/FortWayne311/MapServer/${key}` });
      });

      const map = new EsriMap({
        basemap: this.selectedmap == 'satellite' ? 'streets-vector' : 'satellite',
        layers: [
          new GraphicsLayer(),
          ...layersToAdd
          // new FeatureLayer({ url: this.layerlayer }),
          // new FeatureLayer({ url: this.layerlayer1 })
        ]
      });

      // const map = new EsriMap({
      //   basemap: this.selectedmap == 'satellite' ? 'streets-vector' : 'satellite',
      //   layers: [graphicsLayer],

      // });

      this.esrimapview = new EsriMapView({
        container: this.mapViewEl.nativeElement,
        center: [location.x, location.y],
        zoom: 16, // Adjust the zoom level as needed
        map: map
      });

      // const graphic = new Graphic({
      //   geometry: {
      //     type: "point",
      //     longitude: 0,
      //     latitude: 0
      //   },
      //   attributes: {
      //     ugjb: "Value 1",
      //     jbg: "Value 2",
      //     ugjbb: "Value 3"
      //   },
      //   popupTemplate: popupTemplate
      // });
      //   view.popup.open({
      //     features: [markerGraphic],
      //     location: markerGraphic.geometry,
      //     // Set the position of the popup to the right side
      //     position: "top-right" // You can adjust this based on your preference
      // });

      const toggle = new BasemapToggle({
        view: this.esrimapview,
        nextBasemap: this.selectedmap == 'satellite' ? 'satellite' : 'streets-vector'
      });
      this.esrimapview.ui.add(toggle, {
        position: 'bottom-right'
      });
      // Add the marker graphic to the map
      this.esrimapview.graphics.add(markerGraphic);

      // Show the popup for the marker graphic by default
      this.esrimapview.popup.open({
        features: [markerGraphic],
        location: markerGraphic.geometry
      });
    }
  }

  pan(direction: string, event: Event) {
    const distance = 100; // Adjust the panning distance as needed
    switch (direction) {
      case 'up':
        this.esrimapview.goTo({ center: [this.esrimapview.center.longitude, this.esrimapview.center.latitude + 0.01] });
        break;
      case 'down':
        this.esrimapview.goTo({ center: [this.esrimapview.center.longitude, this.esrimapview.center.latitude - 0.01] });
        break;
      case 'left':
        this.esrimapview.goTo({ center: [this.esrimapview.center.longitude - 0.01, this.esrimapview.center.latitude] });
        break;
      case 'right':
        this.esrimapview.goTo({ center: [this.esrimapview.center.longitude + 0.01, this.esrimapview.center.latitude] });
        break;
    }
    event.preventDefault();
  }

  async initializeMap() {
    console.log('in initialise map');
    try {
      // Load required modules
      const [EsriMap, EsriMapView, Search, BasemapToggle, Locate, Graphic] = await loadModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/widgets/Search',
        'esri/widgets/BasemapToggle',
        'esri/widgets/Locate',
        'esri/Graphic'
      ]);

      // Create a new map
      const mapProperties: esri.MapProperties = {
        basemap: 'satellite'
      };
      const map: esri.Map = new EsriMap(mapProperties);

      // Create a new map view
      const mapViewProperties: esri.MapViewProperties = {
        container: this.mapViewEl.nativeElement,
        center: this._center,
        zoom: this._zoom,
        map: map
      };
      const locationCoords = [-85.1394, 41.7606];
      this.esrimapview = new EsriMapView(mapViewProperties);
      this.esrimapview.goTo({
        target: locationCoords,
        zoom: 10, // Adjust the zoom level as needed
        duration: 1000 // Animation duration in milliseconds
      });
      // Create a new search widget
      const search = new Search({
        view: this.esrimapview,
        searchTerm: this.searchLocation ? this.searchLocation : ''
      });
      console.log(search);
      const toggle = new BasemapToggle({
        view: this.esrimapview,
        nextBasemap: 'streets-vector' // Set the default basemap for the toggle
      });

      this.esrimapview.ui.add(toggle, {
        position: 'bottom-right'
      });
      // Add search widget to the map view
      // mapView.ui.add(search, 'top-right');

      // Wait for the map view to be ready
      const locateWidget = new Locate({
        view: this.esrimapview,
        graphic: 'circle',
        useHeadingEnabled: false,
        goToLocationEnabled: true
      });
      this.esrimapview.when(() => {
        // Create a PictureMarkerSymbol with your custom image
        const customSymbol = {
          type: 'picture-marker',
          url: '../../assets/images/map-pin-red.png',
          width: '32px',
          height: '32px'
        };

        const customGraphic = new Graphic({
          geometry: this.esrimapview.center,
          symbol: customSymbol
        });

        // Set the graphic of the Locate widget to the custom graphic
        locateWidget.graphic = customGraphic;
      });
      this.esrimapview.ui.add(locateWidget, {
        position: 'top-left'
      });
      await this.esrimapview.when();
      this.esrimapview.when(() => {
        this.mapLoaded.emit(true);
        setTimeout(() => {
          search.emit('search-complete');
        }, 5000);
      });

      // Set search input value programmatically
      // if (this.searchLocation) {
      //     search.search(this.searchLocation);
      // }

      // Listen for 'search-complete' event
      // search.on('search-complete', (e: any) => {
      //     if (e && e.results.length > 0 && e.results[0].results.length > 0) {
      //       console.log(e);

      //         const res = e.results[0].results[0];
      //         console.log
      //         const zipCode = res.name.split(',').pop().trim();
      //         let coords: any = {};
      //         if (res.name.includes('AND') || res.name.includes('and') || res.name.includes('&')) {
      //             const address = res.name.split(/AND|and|&/).map((address: any) => address.trim());
      //             const address2 = address[1].split(',').map((address2: any) => address2.trim());
      //             coords = {
      //                 msr_lng: res.feature.geometry.longitude,
      //                 msr_lat: res.feature.geometry.latitude,
      //                 address: address[0],
      //                 address2: address2[0] || '',
      //                 msr_city: address2[1] || '',
      //                 msr_state: address2[2] || '',
      //                 msr_zip: zipCode || '',
      //                 address_t: 'INTERSECTION'
      //             };
      //         } else {
      //             const address = res.name.split(',').map((address: any) => address.trim());
      //             coords = {
      //                 msr_lng: res.feature.geometry.longitude,
      //                 msr_lat: res.feature.geometry.latitude,
      //                 address: address[0],
      //                 address2: '',
      //                 msr_city: address[1] || '',
      //                 msr_state: address[2] || '',
      //                 msr_zip: zipCode || '',
      //                 address_t: 'SINGLE_LINE'
      //             };
      //         }
      //         // Emit the coordinates to the parent component

      //     this.agentscriptservice.isGisVerified=true;
      //         this.childComponentValue.emit(coords);
      //     }
      // });

      //   const locateWidget = new Locate({
      //     view: mapView,
      //     graphic: "circle",
      //     useHeadingEnabled: false,
      //     goToLocationEnabled: true
      // });
      // mapView.when(() => {
      //   // Create a PictureMarkerSymbol with your custom image
      //   const customSymbol = {
      //       type: "picture-marker",
      //       url: "../../assets/images/map-pin-red.png",
      //       width: "32px",
      //       height: "32px"
      //   };

      // Once the view is ready, create a graphic using the custom symbol
      //     const customGraphic = new Graphic({
      //         geometry: mapView.center,
      //         symbol: customSymbol
      //     });

      //     // Set the graphic of the Locate widget to the custom graphic
      //     locateWidget.graphic = customGraphic;
      // });
      //   mapView.ui.add(locateWidget, {
      //       position: "top-left"
      //   });

      //     // Wait for the map to load
      //     await mapView.when();

      //     // Get user's current position

      //     mapView.when(() => {
      //       this.mapLoaded.emit(true);
      //       setTimeout(() => {
      //           search.emit('search-complete');
      //       }, 5000);
      //   });
      // Emit map loaded event
      // this.mapLoaded.emit(true);
    } catch (error) {
      alert('We have an error: ' + error);
    }
  }

  tab_title: any;
  ngOnInit() {
    this.addressvalue = '';
    this.tab_title = $('.custom-tabs li.active').find('a').attr('data-obj-title');

    const Subscription=this.agentscriptservice.addressEmitter.subscribe(address => {
      if (address != null && address.tabId == this.tab_title) {
        address=address.address;
        this.selectedmap = $('.pane:visible [data-basemap-id]').attr('data-basemap-id');

        // Update the searchLocation property and initialize the map
        this.searchLocation = address;
        console.log(this.searchLocation);
        // this.addressvalue=this.searchLocation.text;
        this.addressvalue = this.searchLocation;

        console.log('in emitteeeeeeerrrrrrrrrrrr');
        // console.log(this.selectedmap)
        // this.selectedmap=this.selectedmap
        // this.initializeMap();
        this.geocodeAndCenter(this.addressvalue);
        // console.log(this.queryStringAddress)
      }
      // else return;
      // this.agentscriptservice.emitAddress(0)
    });
    this.esriSubscription.push(Subscription);
    console.log('after emitting service');
    this.searchLocation = this.agentscriptservice.searchAddress;
    console.log(this.searchLocation);
    this.initializeMap();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.searchLocation && !changes.searchLocation.firstChange) {
      this.initializeMap();
    }
  }

}
